import * as yup from 'yup';

// eslint-disable-next-line no-control-regex
export default yup.string().matches(/^[\x00-\xFF]*$/, 'Please only use alphanumeric characters.');
